import React, { Fragment, useCallback, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Row, Modal, ModalHeader, ModalBody, Collapse } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import { useAuth } from '../../Context/Auth/AuthContext';
import PageTitle from '../../Layout/Components/PageTitle';
import Strings from '../../translations/Translations';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import DateHelper from '../../helpers/DateHelper';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

export default function Overview() {
  const history = useHistory();
  const { currentCampaign } = useAuth();

  const [detailsToggle, setDetailsToggle] = useState(true);

  const [modalCreateVideo, setModalCreateVideo] = useState(false);
  const toggleModalCreateVideo = useCallback(() => {
    setModalCreateVideo(!modalCreateVideo);
  }, [setModalCreateVideo, modalCreateVideo]);

  const getEventTypeLabel = useCallback((colevt)=> {
    colevt = parseInt(colevt);
    let label = '';
    
    if (colevt === 2) {
      label = 'Popular';
    } else if (colevt === 4) {
      label = 'Business';
    } else if (colevt === 3) {
      label = 'Modern';
    } else if (colevt === 0) {
      label = 'Music';
    } else if (colevt === 1) {
      label = 'Sports';
    }

    return label;
  }, []);

  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={currentCampaign.coln}
          subheading={currentCampaign.cold}
          icon="pe-7s-display1"
        />

        <Card className='mb-3'>
          <CardHeader id="headingOne">
            <Button
              block
              color='link'
              className="text-left m-0 p-0"
              onClick={() => setDetailsToggle(value => !value)}
              aria-expanded={detailsToggle}
              aria-controls="collapseOne"
            >
              <h3 className="m-0 p-0 pr-2 d-flex justify-content-between">
                {currentCampaign && currentCampaign.coln && currentCampaign.coln}
                {detailsToggle && <IoIosArrowUp />}
                {!detailsToggle && <IoIosArrowDown />}
              </h3>
            </Button>
          </CardHeader>
          <Collapse
            isOpen={detailsToggle}
            data-parent="#accordion"
            id="collapseOne"
            aria-labelledby="headingOne"
          >
            <CardBody>
              {currentCampaign && currentCampaign.cold && (
                <Row className='mb-3'>
                  <Col md={9}>
                    <small>{Strings('description')}</small>
                    <h6 className='mb-0'>{currentCampaign.cold}</h6>
                  </Col>
                  <Col md={3}>
                    <small>{Strings('event_type')}</small>
                    <p className='mb-0'>{getEventTypeLabel(currentCampaign.colevt)}</p>
                  </Col>
                </Row>
              )}

              {currentCampaign && (currentCampaign.colloc || currentCampaign.colad) && (
                <Row className='mb-3'>
                  {currentCampaign.colloc && (
                    <Col md={6}>
                      <small>{Strings('local')}</small>
                      <p className='mb-0'>{currentCampaign.colloc}</p>
                    </Col>
                  )}
                  {currentCampaign.colad && (
                    <Col md={6}>
                      <small>{Strings('address')}</small>
                      <p className='mb-0'>{currentCampaign.colad}</p>
                    </Col>
                  )}
                </Row>
              )}
              
              {currentCampaign && (currentCampaign.colpri || currentCampaign.coltic) && (
                <Row className='mb-3'>
                  {currentCampaign.colpri && (
                    <Col md={6}>
                      <small>{Strings('pricing')}</small>
                      <p className='mb-0'>{currentCampaign.colpri}</p>
                    </Col>
                  )}
                  {currentCampaign.coltic && (
                    <Col md={6}>
                      <small>{Strings('how_to_buy_a_ticket')}</small>
                      <p className='mb-0'>{currentCampaign.coltic}</p>
                    </Col>
                  )}
                </Row>
              )}
              
              {currentCampaign && currentCampaign.colpar && (
                <Row className='mb-3'>
                  <Col md={12}>
                    <small>{Strings('participants')}</small>
                    <p className='mb-0'>{currentCampaign.colpar}</p>
                  </Col>
                </Row>
              )}

              {currentCampaign && (currentCampaign.colurl || currentCampaign.colcurl) && (
                <Row className='mb-3'>
                  {currentCampaign.colurl && (
                    <Col md={6}>
                      <small>{Strings('info_url')}</small>
                      <p className='mb-0'>{currentCampaign.colurl}</p>
                    </Col>
                  )}
                  {currentCampaign.colcurl && (
                    <Col md={6}>
                      <small>{Strings('custom_url')}</small>
                      <p className='mb-0'>{currentCampaign.colcurl}</p>
                    </Col>
                  )}
                </Row>
              )}

              {currentCampaign && (DateHelper.isValidCampaignDate(currentCampaign.colds) || DateHelper.isValidCampaignDate(currentCampaign.colde)) && (
                <Row className='mb-3'>
                  {DateHelper.isValidCampaignDate(currentCampaign.colds) && (
                    <Col md={6}>
                      <small>{Strings('date_start')}</small>
                      <p className='mb-0'>{DateHelper.convertCampaignDate(currentCampaign.colds)}</p>
                    </Col>
                  )}
                  {DateHelper.isValidCampaignDate(currentCampaign.colde) && (
                    <Col md={6}>
                      <small>{Strings('date_end')}</small>
                      <p className='mb-0'>{DateHelper.convertCampaignDate(currentCampaign.colde)}</p>
                    </Col>
                  )}
                </Row>
              )}

              {currentCampaign && currentCampaign.colorg && (
                <Row className='mb-3'>
                  <Col md={12}>
                    <small>{Strings('organized_by')}</small>
                    <p className='mb-0'>{currentCampaign.colorg}</p>
                  </Col>
                </Row>
              )}

              <Row className='mt-4'>
                <Col md={12}>
                  <small>{Strings('created')}</small>
                  <p className='mb-0'>{DateHelper.convertCreateDate(currentCampaign.create_date)}</p>
                </Col>
              </Row>
            </CardBody>
          </Collapse>
        </Card>

        <Row>
          <Col md={12}>
            <Card>
              <CardHeader>
                {Strings('tasks')}
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={12}>
                    <Button
                      color='primary'
                      className='mr-2'
                      onClick={toggleModalCreateVideo}
                    >
                      {Strings('create_video')}
                    </Button>
                    <Link
                      className='btn btn-primary mr-2'
                      to='/campaign/edit'
                    >
                      {Strings('edit')}
                    </Link>
                    <Link
                      className='btn btn-primary mr-2'
                      to='/campaign/share'
                    >
                      {Strings('share')}
                    </Link>
                    <Link
                      className='btn btn-primary mr-2'
                      to='/campaign/manage'
                    >
                      {Strings('videos')}
                    </Link>
                    <Link
                      className='btn btn-primary mr-2'
                      to='/campaign/analyze'
                    >
                      {Strings('analyze')}
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={modalCreateVideo}
          toggle={toggleModalCreateVideo}
        >
          <ModalHeader toggle={toggleModalCreateVideo}>
            {Strings('create_video')}
          </ModalHeader>
          <ModalBody className='text-center'>
            <Button
              size='lg'
              className='mr-2 mb-2'
              outline
              color='primary'
              onClick={() => {
                history.push(`/campaign/create-video?create=2`);
              }}
            >
              {Strings('auto_video')}
            </Button>
            <Button
              size='lg'
              className='mr-2 mb-2'
              outline
              color='primary'
              onClick={() => {
                history.push(`/campaign/create-video`);
              }}
            >
              {Strings('step_by_step')}
            </Button>
          </ModalBody>
        </Modal>

      </PageAnimation>
    </Fragment>
  );
}
